import { getApiClient, initializeApiClient } from "../../apiService";

const UpdateProjectPlan = async (
  pS_ProjectSummaryId,
  mainActivitiesProjectImplementation,
  projectPhases,
  activitiesInSchools,
  educationalContentCreation,
  approvalsForSchoolProjects,
  plannedElectronicContentInfo,
  uniqueProjectValue,
  aI_ApplicationInformationId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/PS_ProjectSummaryEntity/UpdateProjectSummary`,
    {
      pS_ProjectSummaryId: pS_ProjectSummaryId,
      mainActivitiesProjectImplementation: mainActivitiesProjectImplementation,
      projectPhases: projectPhases,
      activitiesInSchools: activitiesInSchools,
      educationalContentCreation: educationalContentCreation,
      approvalsForSchoolProjects: approvalsForSchoolProjects,
      plannedElectronicContentInfo: plannedElectronicContentInfo,
      uniqueProjectValue: uniqueProjectValue,
      aI_ApplicationInformationId: aI_ApplicationInformationId,
    }
  );

  return response.data.result;
};

export default UpdateProjectPlan;
